import { TextInput2, TextInput1 } from "../../../../element/TextInput"
import { View } from 'react-native'
import { LogoTribu } from "../../../../element/Image"
import { Title } from "../../../../element/Text"



const Anagraphic = props => {
  
  return (
    <View style={{with:'90%', height:'90%', alignItems:'center'}}>
      <LogoTribu wsize={'90%'} hsize={'30%'} source={props.tribeimage}/>
      <Title value={props.tribename} color1={'#F9BA49'}/>
      <View style={{height:'70%', marginTop:30, width:'100%', alignItems:'center'}}>
      <TextInput1
        value={props.value}
        onChangeText={props.onChangeText}
        secure={false}
        placeholder={'Nome PG'}
        type={'username'}  errorText={''} 
      />
      <TextInput1
        value={props.value2}
        onChangeText={props.onChangeText2}
        secure={false}
        placeholder={'Segni Particolari'}
        type={'username'}  errorText={''} 
      />
      <TextInput2
      value={props.value1}
      control={props.onChangeText1}
      placeholder={'Background'}
     
      />

</View>
    </View>
  )
}

export default Anagraphic

